import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SelectField } from '../components/Table/fields/SelectField';
import { userByRole } from './userByRole';
import { SPSelectField } from '../components/Table/fields/SPSelectField';
import { enumItems } from './enumItems';
import { service } from './service';
import { SPNumberField } from '../components/Table/fields/SPNumberField';
import { CustomFieldForServiceProviderEventStaffService } from '../components/Table/fields/CustomFieldForServiceProviderEventStaffService';

export const serviceProviderEventStaff: SchemaWithClient<any> = {
  name: 'Service - Event Staff',
  pluralName: 'Service - Event Staff',
  tabs: [
    {
      id: 1,
      label: 'General',
      name: 'general',
    },
  ],
  columns: {
    name: {
      name: 'Name',
      fieldRenderer: TextField,
      fieldType: 'text',
      readOnly: true,
      hide: true,
    },
    service_provider: {
      name: 'Service Provider',
      fieldRenderer: SelectField.tableAdapter(enumItems.serviceProvider),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(
        enumItems.serviceProvider
      ),
      switchboard: true,
      url: enumItems.serviceProvider.client.getAllPath,
      tempSchema: enumItems.serviceProvider,
      readOnly: true,
    },
    event_staff: {
      name: 'Event Staff',
      fieldRenderer: SelectField.tableAdapter(userByRole('9')),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(userByRole('9')),
      switchboard: true,
      url: userByRole('9').client.getAllPath,
      tempSchema: userByRole('9'),
      required: true,
    },
    services: {
      name: 'Services',
      withoutNameColumn: true,
      fieldRenderer: SelectField.tableAdapter(service),
      slidePaneFieldRenderer: CustomFieldForServiceProviderEventStaffService,
      fieldType: 'custom',
      accordingTo: 'service_provider',
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
      hide: true,
    },
  },
  client: new Client('/service-provider-event-staff'),
};
